module.exports = "/images/plus.svg?4633cb6fce526a903ab7d6cd7cf64d80";